<div fxLayout="row" class="background">
  <div fxFlex="80" fxFlexOffset="10%">

    <section id="header">
      <h1 class="h1Header">AGREGAR</h1>
    </section>

    <form [formGroup]="addSliderForm" (ngSubmit)="saveChanges(addSliderForm.value)">
      <mat-card>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxFlex="100">
            <mat-form-field appearance="outline">
              <mat-label>Título</mat-label>
              <input type="text" matInput formControlName="dsTitle">
              <mat-hint>Etiqueta básica de HTML permitida</mat-hint>
              <mat-error *ngIf="addSliderForm.controls['dsTitle'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxFlex="60">
            <mat-form-field appearance="outline">
              <mat-label>Imagen</mat-label>
              <ngx-mat-file-input formControlName="dsImg" accept=".png, .jpeg, .jpg">
              </ngx-mat-file-input>
            </mat-form-field>
          </div>
          <div fxFlex="40">
            <mat-form-field appearance="outline">
              <mat-label>Orden No.</mat-label>
              <input type="text" matInput formControlName="nmSortNo">
              <mat-error *ngIf="addSliderForm.controls['nmSortNo'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </mat-card>
      <br>
      <div fxLayout="row" fxLayoutAlign="start center">
        <button type="submit" mat-raised-button [disabled]="!addSliderForm.valid" class="save-changes">GUARDAR CAMBIOS</button>
        <button routerLink="/start-slider" mat-raised-button class="cancel-changes">CANCELAR</button>
      </div>
    </form>
  </div>
</div>
